'use client'

import { usePagination } from 'react-instantsearch'

type FilterPaginationProps = {
  gridRef?: React.RefObject<HTMLDivElement>
}

export default function FilterPagination({ gridRef }: FilterPaginationProps) {
  const { pages, refine, currentRefinement } = usePagination({
    padding: 2,
  })

  if (!pages?.length) {
    return null
  }

  return (
    <ul role="navigation" className="flex items-center gap-x-l text-17 s:text-14">
      {pages?.length > 1
        ? pages.map((page) => (
            <li key={page}>
              {currentRefinement !== page ? (
                <a
                  href="#"
                  onClick={(event) => {
                    event.preventDefault()

                    refine(page)

                    if (gridRef?.current && gridRef.current !== null) {
                      gridRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest',
                      })
                    }
                  }}>
                  {page + 1}
                </a>
              ) : (
                <strong>{page + 1}</strong>
              )}
            </li>
          ))
        : null}
    </ul>
  )
}
